<template>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  viewBox="0 0 643 121" enable-background="new 0 0 643 121" xml:space="preserve">
	<g>
		<g>
			<path fill="#27387D" d="M123.583,3.836V3.748h-3.47c-0.13,0-0.247-0.011-0.375-0.011v0.011H50.137
				c-23.839,0-35.744,9.614-35.744,28.837v52.941c0,19.101,11.908,28.658,35.744,28.658h69.692v-0.034
				c23.751-0.029,35.638-9.57,35.638-28.626V32.583C155.465,14.407,144.833,4.833,123.583,3.836z M115.955,87.315H58.152V30.012
				h57.803V87.315z"/>
		</g>
		<g>
			<path fill="#27387D" d="M473.349,113.796h-41.473V84.861h-58.064v28.935h-41.453V28.787c0-7.251,2.718-13.013,8.205-17.322
				c5.348-4.185,12.988-6.269,22.923-6.269h78.919c9.935,0,17.57,2.084,22.918,6.269c5.357,4.18,8.025,9.974,8.025,17.322V113.796z
				M431.874,64.857V33.43H373.81v31.427H431.874z"/>
			<path fill="#27387D" d="M622.048,10.638c-4.185-3.325-10.633-5.104-19.271-5.386l0.146-0.038h-1.622
				c-0.347-0.007-0.663-0.019-1.034-0.019h-73.809l-0.031,0.019h-2.412c-9.935,0-17.569,2.07-22.921,6.265
				c-5.351,4.165-8.062,9.791-8.202,16.8h-0.013v0.259c0,0.11-0.009,0.18-0.009,0.273h0.009v84.985h41.478v-28.37h67.049
				c18.209,0,27.316-7.291,27.316-21.95V28.646C628.727,20.281,626.499,14.293,622.048,10.638z M586.53,61.577h-52.749V33.432
				h52.749V61.577L586.53,61.577z"/>
			<path fill="#27387D" d="M280.24,5.195L280.24,5.195h-6.193v63.172c-0.273,0.663-0.866,1.159-2.133,0.935
				c0,0-0.814-0.17-1.389-0.777c-6.999-10.824-33.95-47.869-42.577-59.673c-0.021-0.048-0.069-0.079-0.105-0.125h0.025
				c-0.132-0.132-0.28-0.258-0.428-0.371c-0.065-0.101-0.123-0.18-0.208-0.209c-2.192-1.974-5.071-2.95-8.898-2.95h-33.497
				c-4.217,0-7.452,1.199-9.72,3.549c-2.281,2.381-3.415,5.589-3.465,9.549l-0.062,0.03v95.472h39.178
				c0,0-0.219-50.434-0.323-65.296c0.166-0.986,0.881-2.417,3.871-2.055c0,0,1.15,0.086,1.64,0.955l0,0
				c7.56,12.07,57.097,66.396,57.097,66.396h40.692V5.197H280.24V5.195z"/>
		</g>
		<g>
			<path fill="#EC2727" stroke="#FFFFFF" stroke-width="1.4328" d="M81.054,72.543c0,0,43.898,25.216,53.042,45.215h34.16
				C165.424,111.043,149.143,81.172,81.054,72.543z"/>
		</g>
	</g>
</svg>
</template>

<style lang="scss" scoped>
</style>
